import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_ACCOUNT_ME_QUERY_KEY } from "../../../components/auth/api/authApi";
import { postUpdateProfile, ProfilePayload } from "../api/profileApi";
import { useSettingsToast, extractErrorMessage } from "./useSettingsMutations";

export function useProfileMutation() {
  const toast = useSettingsToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ProfilePayload) => postUpdateProfile(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GET_ACCOUNT_ME_QUERY_KEY });
      toast.success("Profile updated");
    },
    onError: (error: any) => {
      toast.error("Failed to update profile", extractErrorMessage(error));
    },
  });
}
